/** Re-enable when practitioner spotlight launches. Routes and UI remain in code. */
export const PRACTITIONER_SPOTLIGHT_ENABLED = false

/** Re-enable when practitioner directory launches. Routes and UI remain in code. */
export const PRACTITIONER_DIRECTORY_ENABLED = false

export function isPractitionerSpotlightPath(path: string): boolean {
  if (PRACTITIONER_SPOTLIGHT_ENABLED) return false
  return (
    path === '/spotlight'
    || path.startsWith('/spotlight/')
    || path.startsWith('/spotlight-mockup')
    || path.startsWith('/practitioner-spotlight')
    || path.startsWith('/coach/spotlight')
    || path.startsWith('/pro/spotlight')
    || path === '/pro/inquiries'
  )
}

export function isPractitionerDirectoryPath(path: string): boolean {
  if (PRACTITIONER_DIRECTORY_ENABLED) return false
  return path === '/directory' || path.startsWith('/directory/')
}

export function isDisabledPractitionerPath(path: string): boolean {
  return isPractitionerSpotlightPath(path) || isPractitionerDirectoryPath(path)
}
